import Phaser from 'phaser';
import { eventBus, EVENTS } from '../EventBus';
import { ConnectVan } from '../entities/ConnectVan';
import type { ScreenPayload } from '../types';
import { addBrand, drawDigitalCityBackdrop } from './sceneArt';

export class AttractScene extends Phaser.Scene {
  constructor() { super('AttractScene'); }

  create(): void {
    drawDigitalCityBackdrop(this, true);
    this.add.text(800, 116, 'CONNECT 360', {
      fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '96px', fontStyle: 'bold', color: '#ffffff',
      stroke: '#020916', strokeThickness: 12,
    }).setOrigin(0.5).setDepth(5);
    this.add.text(800, 188, 'LIGHT UP THE COMMUNITY', {
      fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '25px', fontStyle: 'bold', color: '#ff6b2a', letterSpacing: 7,
    }).setOrigin(0.5).setDepth(5);
    const town = this.add.graphics().setDepth(3);
    town.fillStyle(0x0c1d32, 0.96).fillRoundedRect(128, 252, 1344, 310, 24);
    town.fillStyle(0x12281f, 0.95).fillRoundedRect(148, 272, 1304, 270, 18);
    town.lineStyle(24, 0x111b2b, 1).lineBetween(190, 450, 1408, 450).lineBetween(340, 320, 340, 510).lineBetween(720, 300, 720, 510).lineBetween(1110, 300, 1110, 510);
    town.lineStyle(3, 0x1ed8ff, 0.48).lineBetween(190, 450, 1408, 450);
    const places = [
      { x: 255, y: 405, label: 'HOME' }, { x: 480, y: 365, label: 'SCHOOL' }, { x: 720, y: 405, label: 'CLINIC' },
      { x: 980, y: 370, label: 'BUSINESS' }, { x: 1260, y: 405, label: 'COMMUNITY HUB' },
    ];
    places.forEach((place, index) => {
      town.fillStyle(0x101d32, 1).fillRoundedRect(place.x - 44, place.y - 44, 88, 70, 8);
      town.lineStyle(4, index === 0 ? 0xff6b2a : 0x315986, 1).strokeRoundedRect(place.x - 44, place.y - 44, 88, 70, 8);
      this.add.text(place.x, place.y + 39, place.label, { fontFamily: 'Arial Black, Arial', fontSize: '10px', color: '#ffffff' }).setOrigin(0.5).setDepth(4);
      const light = this.add.rectangle(place.x, place.y - 10, 32, 19, index === 0 ? 0xffd15c : 0x17345a, 1).setDepth(4);
      this.tweens.add({ targets: light, fillColor: 0xffd15c, duration: 450, delay: 350 + index * 420, yoyo: true, repeat: -1, repeatDelay: 1800 });
    });
    const van = new ConnectVan(this, 205, 450, false).setScale(1.18);
    this.tweens.add({ targets: van, x: 1375, duration: 4800, ease: 'Sine.InOut', yoyo: true, repeat: -1, onYoyo: () => van.face('left'), onRepeat: () => van.face('right') });
    const dataPulse = this.add.circle(190, 450, 8, 0xffffff, 1).setDepth(4);
    this.tweens.add({ targets: dataPulse, x: 1408, duration: 1900, ease: 'Linear', repeat: -1 });

    this.add.text(800, 606, '75 SECONDS.  FIVE CONNECTIONS.  ONE STRONGER COMMUNITY.', {
      fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '22px', color: '#ffffff', letterSpacing: 2,
    }).setOrigin(0.5).setDepth(5);
    this.add.text(800, 646, 'ONE SIGNAL CAN CHANGE AN ENTIRE COMMUNITY.', {
      fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '18px', color: '#1ed8ff', letterSpacing: 3,
    }).setOrigin(0.5).setDepth(5);
    addBrand(this, 842);
    eventBus.emit<ScreenPayload>(EVENTS.screen, { name: 'attract' });
  }
}
